import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import PhotoCard from "@/components/PhotoCard";
import { MagnifyingGlass } from "@phosphor-icons/react";

const EXAMPLES = ["boats", "restaurants", "college", "hibiscus", "airport", "beach"];

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!q) return;
    setResults(null);
    api.get("/search", { params: { q } }).then((r) => setResults(r.data)).catch(() => setResults([]));
  }, [q]);

  return (
    <div className="mx-auto max-w-[1400px]">
      <p className="overline text-[#F27A54]">Natural-language Search</p>
      <h1 className="mt-1 font-display text-3xl font-black tracking-tight">
        {q ? <>Results for "<span className="text-[#F27A54]">{q}</span>"</> : "Search Photos"}
      </h1>

      {!q ? (
        <div className="mt-8">
          <p className="text-sm text-muted-foreground">Search across metadata + AI knowledge: captions, keywords, locations, categories, objects, OCR text, species and manual tags.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {EXAMPLES.map((e) => <a key={e} href={`/search?q=${e}`} className="rounded-sm border border-border px-3 py-1.5 text-sm hover:border-[#F27A54] hover:text-[#F27A54]">{e}</a>)}
          </div>
        </div>
      ) : results === null ? (
        <p className="mt-8 text-muted-foreground">Searching…</p>
      ) : results.length === 0 ? (
        <div className="mt-16 grid place-items-center text-center">
          <MagnifyingGlass size={44} weight="thin" className="text-zinc-300" />
          <p className="mt-3 font-display font-bold">No matches</p>
        </div>
      ) : (
        <>
          <p className="mt-2 text-sm text-muted-foreground">{results.length} photos found</p>
          <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {results.map((p, i) => <PhotoCard key={p.id} photo={p} index={i} />)}
          </div>
        </>
      )}
    </div>
  );
}
